module.exports = __webpack_public_path__ + "static/img/lucre-games-google-play-icon.994e887.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lucre-games-google-play-icon.png
// module id = C+62
// module chunks = 0